__turbopack_context__.v({
  "arrowButton": "BSc2-q_arrowButton",
  "earlyAccessIcon": "BSc2-q_earlyAccessIcon",
  "hidden": "BSc2-q_hidden",
  "leftArrow": "BSc2-q_leftArrow",
  "rightArrow": "BSc2-q_rightArrow",
  "scrollContainer": "BSc2-q_scrollContainer",
  "viewport": "BSc2-q_viewport",
});
